import { ruleMessage } from '@cnamts/vue-dot/src/helpers/ruleMessage';
import { ErrorMessages } from '@cnamts/vue-dot/src/rules/types';

const defaultErrorMessages: ErrorMessages<number> = {
	default: (max: number) => `Vous ne pouvez pas sélectionner plus de ${max} valeurs.`
};

/** Check that the field exceeds the lengthValue length */
export function count(min: number, max: number, errorMessages = defaultErrorMessages) {
	// Return the validation function
	return (value: string | null | []) => {
		let isValid = false;

		if (null === value) {
			isValid = (0 === min);
		}

		if (null !== value) {
			isValid = (max >= value.length && min <= value.length);
		}

		return isValid || ruleMessage(errorMessages, 'default', [max]);
	};
}

export default count;
